import { useWalletsMe } from '@/api/wallets';
import {
  handleChangeAmount,
  setDoubleAmount,
  setHalfAmount,
} from '@/lib/store/games-preferences/actions';
import { useDispatch } from 'react-redux';
import { UseBetAmountInputButtonsReturn } from './props';
import { Nullable } from '@starsoft/common/interfaces';
import { DetailedBet } from '@/models/detailed-bet';
import { BetStatusId } from '@/models/bet/status/id';
import { getMoneyOrAmount } from '@/utils/account/getMoneyOrAmount';

export function useBetAmountInputButtons(
  bet: Nullable<DetailedBet>,
): UseBetAmountInputButtonsReturn {
  const { wallet } = useWalletsMe();
  const balance: number =
    getMoneyOrAmount(wallet?.currentAccount?.balance) ?? 0;
  const dispatch = useDispatch();
  const isDisabled: boolean =
    bet?.status?.id?.toString() == BetStatusId.Open?.toString();

  function handleHalfAmount(): void {
    dispatch(setHalfAmount());
  }

  function handleDoubleAmount(): void {
    dispatch(setDoubleAmount());
  }

  function setMaxAmount() {
    dispatch(handleChangeAmount(balance));
  }

  return {
    handleHalfAmount,
    handleDoubleAmount,
    setMaxAmount,
    isDisabled,
  };
}
